import React from "react";
import { useEffect, useState } from 'react';
import {
    Card,
    Table,
    OverlayTrigger,
    Tooltip,
    Button,
    Col,
    Row,
    Container,
    Form,
} from "react-bootstrap";
import { isEmpty } from "lodash";
import ReactDatetime from "react-datetime";
import { capitalizeFirstLetter } from '../Shared/Helpers';

const StepOne = ({ handleNext, storedData, role }) => {

    const defaultState = {
        workedPrev: 'Please specify',
        selectedFinderJob: '',
        otherFinderText: '',
        selectedTitle: '',
        otherTitleText: '',
        firstName: '',
        secondName: '',
        address: '',
        postcode: '',
        mobile: '',
        telephone: '',
        email: '',
        hasEndorsements: 'Please specify',
        endorsementDetails: '',
        holdDrivingLicense: 'Please specify',
        ukEligible: 'Please specify',
        selectedUKRight: '',
        otherukEligibleText: '',
        hasCriminalOffence: 'Please specify',
        validDate: null
    };

    const [formData, setFormData] = useState(defaultState);

    const handleSelectChange = (event) => {

        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });


        // clear errors when they change selected value
        setErrors({
            ...errors,
            [name]: ""
        });

    };


    const [errors, setErrors] = useState({});

    function isValidDate(dateString) {
        const today = new Date();
        const [day, month, year] = dateString.split("/").map(Number);
        const selectedDate = new Date(year, month - 1, day); // month is zero-based in JavaScript Date

        return selectedDate >= today;
    }


    function handleDateChange(date) {
        const formattedDate = date.format("DD/MM/YYYY");
        setFormData({ ...formData, validDate: formattedDate });
    }

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function isValidPostcode(postcode) {
        const postcodeRegex = /^[A-Za-z]{1,2}\d{1,2}[A-Za-z]?\s*\d[A-Za-z]{2}$/;
        return postcodeRegex.test(postcode);
    }

    function validateForm(formData) {
        const {
            firstName, secondName, address, postcode, email, selectedTitle, otherTitleText,
            selectedFinderJob, otherFinderText, ukEligible, selectedUKRight,
            hasEndorsements, endorsementDetails, otherukEligibleText, telephone, mobile, holdDrivingLicense, hasCriminalOffence
        } = formData;

        const errors = {
            firstName: isEmpty(firstName) && 'First name is required',
            secondName: isEmpty(secondName) && 'Surname is required',
            address: isEmpty(address) && 'Address Information is required',
            postcode: isEmpty(postcode) ? 'Postcode is required' : !isValidPostcode(postcode) ? 'Invalid postcode format' : '',
            email: isEmpty(email) ? 'Email is required' : !isValidEmail(email) ? 'Invalid email format' : '',
            selectedTitle: isEmpty(selectedTitle) && 'Title is required',
            otherTitleText: selectedTitle === 'Other' && isEmpty(otherTitleText) && 'Please enter a title',
            selectedFinderJob: isEmpty(selectedFinderJob) && 'Please select a option on how you came across this job posting.',
            otherFinderText: (selectedFinderJob === 'Other' || selectedFinderJob === 'Existing Employee')
                && isEmpty(otherFinderText)
                ? `${selectedFinderJob === 'Existing Employee' ? 'Please provide the name of the existing employee who referred you.' : 'Please provide information on how you discovered this post'}`
                : '',
            ukEligibleText: ukEligible === "true" && isEmpty(selectedUKRight) && 'Right to work information is required',
            endorsementDetails: hasEndorsements === "true" && isEmpty(endorsementDetails) && 'Please specify endorsements on licence',
            otherukEligibleText: selectedUKRight === 'Other' && isEmpty(otherukEligibleText) && 'Please specify on eligible for employment',
            telephone: !isEmpty(telephone) && telephone.length !== 11 ? "Telephone number must have 11 digits" : null,
            mobile: !isEmpty(mobile) && mobile.length !== 11 ? "Mobile number must have 11 digits" : null,
            validDate: (formData.selectedUKRight === 'Limited Leave in UK' || formData.selectedUKRight === 'VISA') && (!formData.validDate || new Date(formData.validDate) <= new Date()) ? 'Please enter a valid date.' : null,
            workedPrev: formData.workedPrev === "Please specify" && 'Please select whether you have previously worked for FP McCann Ltd',
            holdDrivingLicense: holdDrivingLicense === "Please specify" && 'Please select whether you have a UK Driving licence',
            hasEndorsements: holdDrivingLicense === "true" && hasEndorsements === "Please specify" && 'Please select whether you have any endorsements on your licence',
            ukEligible: ukEligible === "Please specify" && 'Please select whether you are legally eligible for employment in the UK',
            hasCriminalOffence: hasCriminalOffence === "Please specify" && 'Please select whether you have been convicted of a criminal offence, other than a spent conviction under the Rehabilitation Offenders Act, 1974'
        };

        // Additional check to ensure at least one of the two numbers is entered
        if (isEmpty(telephone) && isEmpty(mobile)) {
            errors.telephone = 'At least one phone number (home or mobile) is required';
            errors.mobile = 'At least one phone number (home or mobile) is required';
        }

        return errors;
    }


    const handleSubmit = async () => {
        try {
            const { workedPrev, selectedFinderJob, otherFinderText, selectedTitle, otherTitleText, firstName, secondName, address, postcode,
                mobile, telephone, email, hasEndorsements, endorsementDetails, holdDrivingLicense, ukEligible, selectedUKRight, hasCriminalOffence, otherukEligibleText, validDate } = formData;

            const errors = validateForm(formData);

            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);

                const appJobApplicantsDetailVM = {
                    /*  Id: null,*/
                    /*          JobId: null,*/
                    IsPreviouslyWorked: workedPrev === 'true', // converts to bool after validation 
                    Title: selectedTitle === 'Other' ? `Other - ${otherTitleText}` : selectedTitle,
                    Surname: secondName,
                    FirstName: firstName,
                    Address: address,
                    Postcode: postcode,
                    HomeTel: telephone,
                    MobileTel: mobile,
                    Email: email,
                    UkdrivingLicense: holdDrivingLicense === 'true',// converts to bool after validation 
                    EndorsementsOnLicense: hasEndorsements === 'true' ? endorsementDetails : "No",// converts to bool after validation 
                    PassportOrIdNumber: null,

                    // a few checks based of valid to date 
                    LegallyEligible: ukEligible === "true" ? selectedUKRight === 'Other' ? `Other - ${otherukEligibleText}`
                        : (formData.selectedUKRight === 'Limited Leave in UK' || selectedUKRight === 'VISA')
                            ? `${selectedUKRight} - (Valid Date To ${validDate})`
                            : selectedUKRight
                        : "No",

                    OtherInformation: '', // will be asked later
                    AdjusmentWhenAttendingInterview: null, // will be asked later
                    CreatedDate: null,
                    PlaceToFindJob: `${selectedFinderJob}${isEmpty(otherFinderText) ? '' : ' - ' + otherFinderText}`,
                    HasCriminalOffence: hasCriminalOffence === 'true',
                    savedData: {
                        workedPrev,
                        selectedFinderJob,
                        otherFinderText,
                        selectedTitle,
                        otherTitleText,
                        firstName,
                        secondName,
                        address,
                        postcode,
                        mobile,
                        telephone,
                        email,
                        hasEndorsements,
                        endorsementDetails,
                        holdDrivingLicense,
                        ukEligible,
                        selectedUKRight,
                        hasCriminalOffence,
                        otherukEligibleText,
                        validDate,
                    }
                };

                console.log('new', appJobApplicantsDetailVM);
                handleNext(appJobApplicantsDetailVM);
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }

        } catch (e) {
            // error
            console.log(e);
        }
    }

    useEffect(() => {
        if (formData.holdDrivingLicense !== "true") {
            setFormData(prevState => ({
                ...prevState,
                endorsementDetails: "",
                hasEndorsements: "Please specify"
            }));
        }

    }, [formData.holdDrivingLicense]);


    useEffect(() => {
        if (formData.hasEndorsements !== "true") {
            setFormData(prevState => ({
                ...prevState,
                endorsementDetails: "",
            }));
        }

        if (formData.ukEligible  !== "true") {
            setFormData(prevState => ({
                ...prevState,
                selectedUKRight: "",
            }));
        }

    }, [formData.hasEndorsements, formData.ukEligible]);

    useEffect(() => {
        // stores the data between the steps
        window.scrollTo(0, 0)

        if (storedData && storedData.savedData) {
            console.log(`storedData is not empty, length: ${storedData.savedData.length}`);
            /*            console.log(storedData.savedData);*/
            const { savedData } = storedData;
            setFormData(savedData);
        } else {
            console.log("storedData is empty");
        }
    }, []);


    return (
        <Row>
            <Col sm={12} md={12}>
                <h2 >1. Vacancy Information</h2>
                <p style={{ marginTop: '-15px' }}>Please fill out all required fields</p>
            </Col>

            <Col sm={12} md={12} className="my-0">
                <h5>Vacancy applied for:</h5>
                <label
                    className="vacancyLabel"
                    disabled={true}
                >
                    {role}
                </label>
            </Col>


            <Col sm={12} md={12} className="my-0">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <h5 style={{ marginRight: "15px" }}>
                        Have you previously worked for FP McCann Ltd?: <span className="star">*</span>
                    </h5>
                    <select
                        id="workedPrev"
                        name="workedPrev"
                        value={formData.workedPrev}
                        onChange={handleSelectChange}
                    >
                        <option value="Please specify">Please specify</option>
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                    </select>
                    {errors.workedPrev && <Form.Text className="text-danger"> <span className="star">*</span> {errors.workedPrev} </Form.Text>}
                </div>
            </Col>


            <Col sm={12} md={6} className="my-1">
                <h5>How did you find out about the job?:<span className="star">*</span></h5>
                <select
                    id="finder-select"
                    name="finder"
                    onChange={(e) => {
                        setFormData(prevState => ({
                            ...prevState,
                            selectedFinderJob: e.target.value,
                            otherFinderText: (e.target.value !== "Other" && e.target.value !== "Existing Employee") ? "" : prevState.otherFinderText
                        }));
                    }}
                    value={formData.selectedFinderJob}
                    className={errors.selectedFinderJob ? "form-control is-invalid custom-input" : "form-control custom-input"}>
                    <option value="">-Please Select-</option>
                    <option value="Company Website">Company Website</option>
                    <option value="Existing Employee">Existing Employee</option>
                    <option value="Friend">Friend</option>
                    <option value="Newspaper">Newspaper</option>
                    <option value="Other">Other</option>

                </select>
                {errors.selectedFinderJob && <Form.Text className="text-danger"> <span className="star">*</span> {errors.selectedFinderJob} </Form.Text>}
            </Col>


            <Col sm={12} md={6} className="my-1">
                <h5>Please specify:</h5>
                <Form.Group>
                    <Form.Control className={errors.otherFinderText ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        value={formData.otherFinderText}
                        onChange={(event) => setFormData(prevState => ({
                            ...prevState,
                            otherFinderText: event.target.value
                        }))}
                        disabled={formData.selectedFinderJob === "Existing Employee" || formData.selectedFinderJob === "Other" ? false : true}
                        type="text" />
                </Form.Group>
                {errors.otherFinderText && <Form.Text className="text-danger"> <span className="star">*</span> {errors.otherFinderText} </Form.Text>}
            </Col>


            <Col sm={12} md={12} style={{ textAlign: 'left', marginBottom: '-10px' }}>
                <h2>Applicant Details</h2>
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Title:<span className="star">*</span></h5>
                <select
                    value={formData.selectedTitle}
                    id="title-select"
                    name="title"
                    className={errors.selectedTitle ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    onChange={(e) => {
                        setFormData(prevState => ({
                            ...prevState,
                            selectedTitle: e.target.value,
                            otherTitleText: (e.target.value !== "Other") ? "" : prevState.otherTitleText
                        }));
                    }}
                >
                    <option value="">-Please Select-</option>
                    <option value="Mr">Mr</option>
                    <option value="Mrs">Mrs</option>
                    <option value="Miss">Miss</option>
                    <option value="Ms">Ms</option>
                    <option value="Other">Other</option>
                </select>
                {errors.selectedTitle && <Form.Text className="text-danger"> <span className="star">*</span> {errors.selectedTitle} </Form.Text>}
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Please specify:</h5>
                <Form.Group>
                    <Form.Control className={errors.otherTitleText ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        disabled={formData.selectedTitle !== "Other"}
                        value={formData.otherTitleText}
                        onChange={(e) => {
                            setFormData(prevState => ({
                                ...prevState,
                                otherTitleText: e.target.value,
                            }));
                        }}
                        type="text" />
                </Form.Group>
                {errors.otherTitleText && <Form.Text className="text-danger"> <span className="star">*</span> {errors.otherTitleText} </Form.Text>}
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>First Name(s):<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData.firstName}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                firstName: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.firstName ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.firstName && <Form.Text className="text-danger"> <span className="star">*</span> {errors.firstName} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Surname:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control
                        className={errors.secondName ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        type="text"
                        value={formData.secondName}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                secondName: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                    />
                    {errors.secondName && <Form.Text className="text-danger"> <span className="star">*</span> {errors.secondName} </Form.Text>}
                </Form.Group>

            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Address (Including Town Or City):<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control
                        className={errors.address ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        type="text"
                        maxLength={225}
                        value={formData.address}
                        onChange={(e) => {
                            setFormData(prevState => ({
                                ...prevState,
                                address: e.target.value,
                            }));
                        }}
                    />
                    {errors.address && <Form.Text className="text-danger"> <span className="star">*</span> {errors.address} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Postcode:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control
                        className={errors.postcode ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        type="text"
                        value={formData.postcode}
                        onChange={(e) => {
                            setFormData(prevState => ({
                                ...prevState,
                                postcode: e.target.value,
                            }));
                        }}
                    />
                    {errors.postcode && <Form.Text className="text-danger"> <span className="star">*</span> {errors.postcode} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Home Tel No:</h5>
                <Form.Group>
                    <Form.Control
                        className={errors.telephone ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        value={formData.telephone}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // Only allow numbers

                                const inputValue = value.slice(0, 11); // Limit input to 11 digits

                                setFormData(prevState => ({
                                    ...prevState,
                                    telephone: inputValue,
                                }));
                            }
                        }}
                        type="text"
                        pattern="[0-9]*"
                    />
                </Form.Group>
                {errors.telephone && <Form.Text className="text-danger"> <span className="star">*</span> {errors.telephone} </Form.Text>}
            </Col>

            <Col sm={12} md={6} className="my-1">
                <h5>Mobile Tel No:</h5>
                <Form.Group>
                    <Form.Control
                        className={errors.mobile ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        value={formData.mobile}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // Only allow numbers

                                const inputValue = value.slice(0, 11); // Limit input to 11 digits

                                setFormData(prevState => ({
                                    ...prevState,
                                    mobile: inputValue,
                                }));
                            }
                        }}
                        type="text"
                        pattern="[0-9]*"
                    />
                    {errors.mobile && <Form.Text className="text-danger"> <span className="star">*</span> {errors.mobile} </Form.Text>}
                </Form.Group>
            </Col>


            <Col sm={12} md={12} className="my-1">
                <h5>Email Address:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control
                        className={errors.email ? "form-control is-invalid custom-input" : "form-control custom-input"}
                        type="text"
                        value={formData.email}
                        onChange={(e) => {
                            setFormData(prevState => ({
                                ...prevState,
                                email: e.target.value,
                            }));
                        }}

                    />
                    {errors.email && <Form.Text className="text-danger"> <span className="star">*</span> {errors.email} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={6} md={12} className="my-0">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <h5 style={{ marginRight: "15px" }}>
                        Do you hold a current UK Driving licence?: <span className="star">*</span>
                    </h5>
                    <select
                        id="holdDrivingLicense"
                        name="holdDrivingLicense"
                        value={formData.holdDrivingLicense}
                        onChange={handleSelectChange}
                    >
                        <option value="Please specify">Please specify</option>
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                    </select>
                    {errors.holdDrivingLicense && <Form.Text className="text-danger" style={{ marginLeft: "10px" }}> <span className="star">*</span> {errors.holdDrivingLicense} </Form.Text>}
                </div>
            </Col>




            {formData.holdDrivingLicense === "true" && (
                <Col sm={6} md={12} className="my-0">
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <h5 style={{ marginRight: "15px" }}>
                            Have you any endorsements on your licence?: <span className="star">*</span>
                        </h5>
                        {/*<input type="checkbox" style={{ marginRight: "5px", transform: "scale(1.2)" }}*/}

                        {/*    onChange={(event) =>*/}
                        {/*        setFormData((prevState) => ({*/}
                        {/*            ...prevState,*/}
                        {/*            hasEndorsements: event.target.checked,*/}
                        {/*        }))}*/}
                        {/*    checked={formData.hasEndorsements}*/}
                        {/*/>*/}

                        <select
                            id="hasEndorsements"
                            name="hasEndorsements"
                            value={formData.hasEndorsements}
                            onChange={handleSelectChange}
                        >
                            <option value="Please specify">Please specify</option>
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                        {errors.hasEndorsements && <Form.Text className="text-danger" style={{ marginLeft: "10px" }}> <span className="star">*</span> {errors.hasEndorsements} </Form.Text>}
                    </div>
                </Col>
            )}

            {formData.hasEndorsements === "true" && (
                <Col sm={6} md={12} className="my-1">
                    <h5> <u>Please specify endorsements:</u></h5>
                    <Form.Group>
                        <Form.Control className={errors.endorsementDetails ? "form-control is-invalid custom-input" : "form-control custom-input"}
                            value={formData.endorsementDetails}
                            onChange={(event) =>
                                setFormData((prevState) => ({
                                    ...prevState,
                                    endorsementDetails: event.target.value,
                                }))}

                            type="text" />
                        {errors.endorsementDetails && <Form.Text className="text-danger"> <span className="star">*</span> {errors.endorsementDetails} </Form.Text>}
                    </Form.Group>
                </Col>
            )}



            <Col sm={6} md={12} className="my-0">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <h5 style={{ marginRight: "15px" }}>
                        Are you legally eligible for employment in the UK?: <span className="star">*</span>
                    </h5>
                    {/*<input type="checkbox" style={{ marginRight: "5px", transform: "scale(1.2)" }}*/}
                    {/*    onChange={(event) =>*/}
                    {/*        setFormData((prevState) => ({*/}
                    {/*            ...prevState,*/}
                    {/*            ukEligible: event.target.checked,*/}
                    {/*        }))}*/}
                    {/*    checked={formData.ukEligible}*/}
                    {/*/>*/}
                    <select
                        id="ukEligible"
                        name="ukEligible"
                        value={formData.ukEligible}
                        onChange={handleSelectChange}
                    >
                        <option value="Please specify">Please specify</option>
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                    </select>
                    {errors.ukEligible && <Form.Text className="text-danger" style={{ marginLeft: "10px" }}> <span className="star">*</span> {errors.ukEligible} </Form.Text>}
                </div>
            </Col>

            {formData.ukEligible === "true" && (
                <>
                    <Col sm={12} md={6} className="my-1">
                        <h5>If YES, which right to work applies to you?:<span className="star">*</span></h5>
                        <select
                            id="title-select"
                            name="title"
                            className={errors.ukEligibleText ? "form-control is-invalid custom-input" : "form-control custom-input"}

                            onChange={(e) => {
                                setFormData(prevState => ({
                                    ...prevState,
                                    selectedUKRight: e.target.value,
                                    otherukEligibleText: (e.target.value !== "Other") ? "" : prevState.otherukEligibleText
                                }));
                            }}
                            value={formData.selectedUKRight}
                        >
                            <option value="">-Please Select-</option>
                            <option value="Indefinite Leave to Remain (ILR)">Indefinite Leave to Remain (ILR)</option>
                            <option value="Irish Citizen">Irish Citizen</option>
                            <option value="Limited Leave in UK">Limited Leave in UK</option>
                            <option value="UK Passport or Birth Certificate">UK Passport or Birth Certificate</option>
                            <option value="VISA">VISA</option>
                            <option value="Other">Other</option>
                        </select>
                        {errors.ukEligibleText && <Form.Text className="text-danger"> <span className="star">*</span> {errors.ukEligibleText} </Form.Text>}
                    </Col>

                    {formData.selectedUKRight === 'Limited Leave in UK' || formData.selectedUKRight === 'VISA' ? (
                        <Col sm={12} md={6} className="my-1">
                            <h5>Valid to date:<span className="star">*</span></h5>
                            <Form.Group>
                                <ReactDatetime
                                    inputProps={{
                                        className: "form-control custom-input",
                                        name: "contact",
                                        disabled: false
                                    }} defaultValue={new Date()}
                                    value={formData.validDate}
                                    onChange={handleDateChange}
                                    timeFormat={false} // Set this to false to remove the time
                                    dateFormat="DD/MM/YYYY" // You can customize the date format here, if needed
                                />
                            </Form.Group>
                            {errors.validDate && <Form.Text className="text-danger"> <span className="star">*</span> {errors.validDate} </Form.Text>}
                        </Col>
                    ) : null}

                    {formData.selectedUKRight === "Other" &&
                        <Col sm={12} md={6} className="my-1">
                            <h5>Please specify:</h5>
                            <Form.Group>
                                <Form.Control className={errors.otherukEligibleText ? "form-control is-invalid custom-input" : "form-control custom-input"}
                                    disabled={formData.selectedUKRight !== "Other"}
                                    value={formData.otherukEligibleText}
                                    onChange={(e) => {
                                        setFormData(prevState => ({
                                            ...prevState,
                                            otherukEligibleText: e.target.value,
                                        }));
                                    }}
                                    type="text" />
                            </Form.Group>
                            {errors.otherukEligibleText && <Form.Text className="text-danger"> <span className="star">*</span> {errors.otherukEligibleText} </Form.Text>}
                        </Col>
                    }
                </>
            )}




            <Col sm={6} md={12} style={{ display: "flex", alignItems: "start" }}>
                <h5><strong><u>Rehabilitation of Offenders Act, 1974</u></strong></h5>
            </Col>

            <Col sm={6} md={12} className="my-0">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <h5 style={{ marginRight: "15px" }}>
                        Have you ever been convicted of a criminal offence, other than a spent
                        conviction under the Rehabilitation Offenders Act, 1974?: <span className="star">*</span>
                    </h5>
                    {/*<input type="checkbox" style={{ marginRight: "5px", transform: "scale(1.2)" }}*/}
                    {/*    onChange={(event) =>*/}
                    {/*        setFormData((prevState) => ({*/}
                    {/*            ...prevState,*/}
                    {/*            hasCriminalOffence: event.target.checked,*/}
                    {/*        }))}*/}
                    {/*    checked={formData.hasCriminalOffence}*/}
                    {/*/>*/}
                    <select
                        id="hasCriminalOffence"
                        name="hasCriminalOffence"
                        value={formData.hasCriminalOffence}
                        onChange={handleSelectChange}
                    >
                        <option value="Please specify">Please specify</option>
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                    </select>
                    {errors.hasCriminalOffence && <Form.Text className="text-danger" style={{ marginLeft: "10px" }}> <span className="star">*</span> {errors.hasCriminalOffence} </Form.Text>}
                </div>
                <Row>
                    <p>(Failure to disclose such information may result in dismissal or disciplinary action by FP McCann.  This information will be treated as confidential and will not necessarily preclude you from employment)</p>
                </Row>
            </Col>

            <Col sm={12} className="d-flex justify-content-end mt-3">
                <Button onClick={handleSubmit} variant="success" className="btn-lg btn-shadow">Next Step</Button>
            </Col>
        </Row>


    );
};

export default StepOne;